import { EntityApiService } from '@dofleini/security';

import { authentication } from '@/settings';

class ExportEntitiesApiService extends EntityApiService {

}

export default new ExportEntitiesApiService(`${authentication.path}/api/export-entities`);
